import React from "react";
import { handleGoingUp, scroll_to } from ".././helper/scroll";

export function Navbar() {
  // list of sentences to display
  const sentences = [
    "ls -la",
    "I enjoy a bit of gaming👾",
    "rosrun turtlesim turtlesim_node",
    "XD",
    "I'm a software developer!",
    "cd ~/homework_folder",
    "lorem ipsum dolor sit amet",
    "c++ -o main main.cpp",
    "sometimes I play the piano🎹",
    "insert text here...🤔",
    "I like to code 👨‍💻",
    "I make websites🌐",
    "localhost:3000",
    "192.168.0.1",
  ];

  /* The code defines a regular expression `emojiRegex` that matches a wide range of Unicode characters
  representing emojis. The `emoji_index` function takes a string `sentence` as input and returns the
  index of the first emoji character in the string, or -1 if no emoji is found. This function is used
  in the `handleChangeText` and `add_text` functions to handle the addition and deletion of emojis in
  the text displayed in the navbar.
  */
  const emojiRegex = /[\u{1f300}-\u{1f5ff}\u{1f900}-\u{1f9ff}\u{1f600}-\u{1f64f}\u{1f680}-\u{1f6ff}\u{2600}-\u{26ff}\u{2700}-\u{27bf}\u{1f1e6}-\u{1f1ff}\u{1f191}-\u{1f251}\u{1f004}\u{1f0cf}\u{1f170}-\u{1f171}\u{1f17e}-\u{1f17f}\u{1f18e}\u{3030}\u{2b50}\u{2b55}\u{2934}-\u{2935}\u{2b05}-\u{2b07}\u{2b1b}-\u{2b1c}\u{3297}\u{3299}\u{303d}\u{00a9}\u{00ae}\u{2122}\u{23f3}\u{24c2}\u{23e9}-\u{23ef}\u{25b6}\u{23f8}-\u{23fa}]/gu;
  let emoji_index = (sentence: string) => sentence.search(emojiRegex);

  let handle_change_text = () => {
    const title = document.querySelector(".change-text");

    if (title && sentences.includes(title.innerHTML.trim())) {
      const current_text = title.innerHTML.trim();

      // delete the text in the change-text letter by letter
      let imp = emoji_index(title.innerHTML);
      if (imp == -1) {
        delete_text(title, current_text, title.innerHTML.length);
      } else {
        // delete the emoji from the text
        delete_text(title, current_text, imp);
      }
    }
  };

  let delete_text = (title: Element, current_text: string, index: number) => {
    const interval = setInterval(() => {
      if (index > 0) {
        title.innerHTML = title.innerHTML.slice(0, index - 1);
        index--;
      } else {
        clearInterval(interval);
        // add the text in the change-text letter by letter
        add_text(current_text);
      }
    }, 20);
  };

  /**
   * The function returns the next element in an array of sentences, given the current element.
   * @param {string} current_text - A string representing the current sentence or text element.
   * @returns The function `get_next_element` returns the next element in the `sentences` array after the
   * `current_text` parameter. If the `current_text` parameter is the last element in the array, the
   * function returns the first element of the array.
   */
  let get_next_element = (current_text: string) => {
    const curr_index = sentences.indexOf(current_text);
    return sentences[curr_index + 1 < sentences.length ? curr_index + 1 : 0];
  };

  let add_text = (current_text: string) => {
    const text = get_next_element(current_text);
    const title = document.querySelector(".change-text");

    if (title!.innerHTML == "") {
      let imp = emoji_index(text);
      if (imp == -1) {
        add_text_helper(text, title!, text.length);
      } else {
        // add the emoji to the text
        add_text_helper(text, title!, imp);
        setTimeout(() => {
          // wait for add to finish
          title!.innerHTML += text.slice(imp, text.length);
        }, 20 * imp);
      }
    }
  };

  let add_text_helper = (text: string, title: Element, end_index: number) => {
    let i = 0;
    const interval = setInterval(() => {
      if (i < end_index) {
        title.innerHTML += text[i];
        i++;
      } else {
        clearInterval(interval);
      }
    }, 20);
  };

  return (
    <div className="navbar">
      <a className="navbar-text" onClick={() => handleGoingUp()}>
        <span className="terminal">~ $</span>
        <div className="navbar-terminal" onMouseEnter={handle_change_text}>
          <span className="change-text">
            {sentences[Math.floor(Math.random() * sentences.length)]}
          </span>
          <span className="breathe"> | </span>
        </div>
      </a>

      <div className="navbar-items">
        <div onClick={() => scroll_to("about")} className="item">
          About
        </div>
        <div onClick={() => scroll_to("projects")} className="item">
          Projects
        </div>
      </div>
    </div>
  );
}
